import {
    Backdrop,
    Box,
    Button,
    Checkbox,
    CircularProgress,
    FormControl,
    Grid, IconButton, InputAdornment,
    InputLabel,
    MenuItem,
    Pagination,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Tooltip
} from "@mui/material";
import React, {useEffect, useState} from "react";
import axios from "axios";
import "./CertificateFilesFetcher.css";
import {AiOutlineClear, AiOutlineFile, AiOutlineSearch} from "react-icons/ai";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch} from "@fortawesome/free-solid-svg-icons";
import CustomAlert from "../../components/ConfirmationModal/CustomAlert";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import {FaFileAlt, FaFileArchive, FaSearch} from "react-icons/fa";
import DocTypesEnum from "../../enums/DocTypesEnum";
import {MdClose} from "react-icons/md";
import {ka} from "date-fns/locale";
import DatePicker from "react-datepicker";
import {ClearIcon} from "@mui/x-date-pickers";

function formatDate(dateString) {

    if (dateString === null) {
        return ""
    }

    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
}

const DocumentsTable = () => {
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [fileTypeFilter, setFileTypeFilter] = useState(null);
    const [isDocumentSigned, setIsDocumentSigned] = useState(null);
    const [caseNumberFilter, setCaseNumberFilter] = useState('');
    const [FilTredByNameFilter, setFilTredByNameFilter] = useState('');
    const optionsForFileTypeFilter = Object.values(DocTypesEnum).map(d => ({
        value: d.id,
        label: d.title
    }));


    const [formData, setFormData] = useState({
        DocumentTypeIds: null,
        isDocumentSigned: null,
        createdAtFrom: null,
        createdAtTo: null,
        caseNumberFilter: '',
        FilTredByNameFilter: '',
    });
    const [filesList, setFilesList] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [documentIds, setDocuementIds] = useState([]);
    const [permitTypes, setPermitTypes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const [isDownloading, setIsDownloading] = useState(false);
    const [resetFilters, setResetFilters] = useState(false);
    const delay = ms => new Promise(res => setTimeout(res, ms));


    const handleSelect = (id) => {
        const currentIndex = selectedFiles.indexOf(id);
        const newSelectedFiles = [...selectedFiles];

        if (currentIndex === -1) {
            newSelectedFiles.push(id);
        } else {
            newSelectedFiles.splice(currentIndex, 1);
        }

        setSelectedFiles(newSelectedFiles);
    };


    const findObjectNameById = (objectId) => {
        const object = permitTypes.find(child => child.id === objectId)
        return object ? object.title : ""
    };

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedFiles(documentIds);
            return;
        }
        setSelectedFiles([]);
    };

    const isSelected = (id) => selectedFiles.includes(id);


    useEffect(() => {
        void fetchFiles();
    }, [page, pageSize]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetPermitTypeTree`);
                const data = response.data.data;

                const findLastChildren = (nodes) => {
                    let children = [];
                    nodes.forEach(node => {
                        if (node.childrenPermitTypes && node.childrenPermitTypes.length > 0) {
                            children = [...children, ...findLastChildren(node.childrenPermitTypes)];
                        } else {
                            children.push(node);
                        }
                    });
                    return children;
                };

                const lastNode = data[data.length - 1];
                const lastNodeChildren = findLastChildren([lastNode]);
                setPermitTypes(lastNodeChildren);
            } catch (error) {
            }
        };

        void fetchData();
    }, []);


    const fetchFiles = async () => {
        setLoading(true);
        const params = new URLSearchParams({
            ...formData,
            DocumentTypeIds: fileTypeFilter,
            isDocumentSigned: isDocumentSigned,
            CaseNumber: caseNumberFilter,
            FilTredByName: FilTredByNameFilter,
            CreateAtFrom: formData.createdAtFrom ? formData.createdAtFrom.toISOString() : (formData.createdAtTo? new Date('1970-01-01').toISOString() : null),
            CreateAtTo: formData.createdAtTo ? formData.createdAtTo.toISOString() : (formData.createdAtFrom ? new Date('2100-01-01').toISOString() : null),
        });

        try {
            const fetchPromise = axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllFiltredCaseFile?${params}&Page=${page - 1}&PageSize=${pageSize}`);
            const [response] = await Promise.all([fetchPromise, delay(1500)]);
            const {data} = response;
            if (data.success === true && data.data !== null) {
                setFilesList(data.data.resultItems !== null ? data.data.resultItems : []);
                setTotalCount(data.data.totalCount !== null ? data.data.totalCount : 0);
                setDocuementIds(data.data.nonFiltredResultItemIds !== null ? data.data.nonFiltredResultItemIds : []);
                setShowAlert(false);
                setAlertMessage('');
                setAlertType('');
            } else {
                setFilesList([]);
                setTotalCount(0);
                setDocuementIds([]);

            }
        } catch (error) {
            console.error('Fetching data failed:', error);
            setShowAlert(true);
            setAlertMessage('დაფიქსირდა შეცდომა, ცადეთ მოგვიანებით!');
            setAlertType('error');
        } finally {
            setLoading(false);
        }
    };


    const clearForm = () => {
        setFormData({
            DocumentTypeIds: null,
            isDocumentSigned: null,
            createdAtFrom: null,
            createdAtTo: null,
            caseNumberFilter: '',
            FilTredByNameFilter: '',
        });
        setFileTypeFilter(null)
        setIsDocumentSigned(null)
        setCaseNumberFilter('')
        setFilTredByNameFilter('')
        setResetFilters(true)
    };

    useEffect(() => {
        if (resetFilters) {
            void fetchFiles();
            setResetFilters(false);
        }
    }, [resetFilters]);

    const handleChange = (name, value) => {
        setFormData(prevState => ({...prevState, [name]: value}));
    };

    const handleDownload = async () => {
        setIsDownloading(true);
        const payload = {
            casefileIds: selectedFiles
        };

        try {
            const fetchPromise = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/CaseFilesDocumentsDownloadZip`, payload, {
                responseType: 'blob',
            });

            const [response] = await Promise.all([fetchPromise, delay(1500)]);

            const file = new Blob([response.data], {
                type: 'application/zip'
            });

            const fileURL = URL.createObjectURL(file);

            const fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', "უწყებრივი რეესტრის დოკუმენტები");
            document.body.appendChild(fileLink);

            fileLink.click();

            fileLink.parentNode.removeChild(fileLink);
        } catch (error) {
        } finally {
            setIsDownloading(false);
        }
    };

    return (
        <div style={isDownloading ? {cursor: 'wait'} : {}} className={"certificate-files-fetcher-wrapper"}>
            <Box>
                <Backdrop open={isDownloading}
                          style={{zIndex: 1000, color: '#fff', backgroundColor: 'rgba(0, 0, 0, 0.9)'}}
                >
                    <div style={{textAlign: 'center', alignItems: 'center', justifyContent: 'center'}}>
                        <FaFileArchive style={{fontSize: 80, color: '#fff'}} className={"pulse-element"}/>
                        <h1>გთხოვთ დაელოდოთ...</h1>
                        <p>არქივი გენერირდება!</p>
                    </div>
                </Backdrop>
                <div>

                    <div className={"certificate-files-input-container"}>

                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl fullWidth>
                                <InputLabel id="region-label">დოკუმენტის ტიპი</InputLabel>
                                <Select
                                    variant="outlined"
                                    labelId="doctype-label"
                                    className="slide-in-input"
                                    value={fileTypeFilter}
                                    label="დოკუმენტის ტიპი"
                                    onChange={(e) => setFileTypeFilter(e.target.value)}
                                    endAdornment={
                                        fileTypeFilter !== null && (
                                            <IconButton size="small" onClick={() => setFileTypeFilter(null)}>
                                                <ClearIcon />
                                            </IconButton>
                                        )
                                    }
                                >
                                    {optionsForFileTypeFilter.map((option) => (
                                        <MenuItem key={option.value} value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                    <MenuItem key={5555} value={5555}>
                                        წერილი მომეტებული ტექნიკური საფრთხის შემცველი ობიექტის რეგისტრაციაზე
                                    </MenuItem>
                                    <MenuItem key={27015} value={27015}>
                                        სანბართვო მოწმობა
                                    </MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl fullWidth>
                                <InputLabel id="region-label">აქვს ხელმოწერა</InputLabel>
                                <Select
                                    variant="outlined"
                                    labelId="doctype-label"
                                    className="slide-in-input"
                                    value={isDocumentSigned}
                                    label="აქვს ხელმოწერა"
                                    onChange={(e) => setIsDocumentSigned(e.target.value)}
                                    endAdornment={
                                        isDocumentSigned !== null && (
                                            <IconButton size="small" onClick={() => setIsDocumentSigned(null)}>
                                                <ClearIcon />
                                            </IconButton>
                                        )
                                    }
                                >
                                    <MenuItem value={true}>კი</MenuItem>
                                    <MenuItem value={false}>არა</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl fullWidth>
                                <TextField
                                    label="განაცხადის ნომერი"
                                    variant="outlined"
                                    value={caseNumberFilter}
                                    onChange={(e) => setCaseNumberFilter(e.target.value)}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <FormControl fullWidth>
                                <TextField
                                    label="დოკუმენტის სახელი"
                                    variant="outlined"
                                    value={FilTredByNameFilter}
                                    onChange={(e) => setFilTredByNameFilter(e.target.value)}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <DatePicker
                                selected={formData.createdAtFrom}
                                onChange={(newValue) => handleChange('createdAtFrom', newValue)}
                                customInput={<TextField className={"slide-in-input"} label="დოკუმენტის შექმნის თარიღიდან"
                                                        variant="outlined" InputProps={{
                                    endAdornment: formData.createdAtFrom !== null ? (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => {
                                                    handleChange('createdAtFrom', null)
                                                }}
                                                edge="end"
                                            >
                                                <MdClose/>
                                            </IconButton>
                                        </InputAdornment>
                                    ) : null,
                                }}/>}

                                autoComplete="off"
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                className="certificate-files-datepicker-search"
                                scrollableYearDropdown
                                dateFormat="dd/MM/yyyy"
                                locale={ka}
                                popperProps={{
                                    positionFixed: true
                                }}

                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <DatePicker
                                selected={formData.createdAtTo}
                                onChange={(newValue) => handleChange('createdAtTo', newValue)}
                                customInput={<TextField className={"slide-in-input"} label="დოკუმენტის შექმნის თარიღამდე"
                                                        variant="outlined" InputProps={{
                                    endAdornment: formData.createdAtTo !== null ? (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => {
                                                    handleChange('createdAtTo', null)
                                                }}
                                                edge="end"
                                            >
                                                <MdClose/>
                                            </IconButton>
                                        </InputAdornment>
                                    ) : null,
                                }}/>}

                                autoComplete="off"
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                className="certificate-files-datepicker-search"
                                scrollableYearDropdown
                                dateFormat="dd/MM/yyyy"
                                locale={ka}
                                popperProps={{
                                    positionFixed: true
                                }}

                            />
                        </Grid>

                    </div>
                    <div style={{display: "flex", gap: 10}}>
                        <Button
                            onClick={fetchFiles}
                            variant="contained"
                            color="primary"
                            fullWidth
                            endIcon={<AiOutlineSearch/>}
                        >
                            ძიება
                        </Button>
                        <Button
                            onClick={clearForm}
                            variant="contained"
                            color="error"
                            fullWidth
                            endIcon={<AiOutlineClear/>}
                        >
                            ფილტრების წაშლა
                        </Button>

                        <Tooltip
                            title={selectedFiles.length === 0 ? "გადმოწერისთვის აირჩიეთ დოკუმენტები!" : ""}>
                            <span
                                style={{cursor: selectedFiles.length === 0 ? 'not-allowed' : 'pointer', width: "100%"}}>
                                <Button
                                    onClick={handleDownload}
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    disabled={selectedFiles.length === 0 || isDownloading}
                                    endIcon={<CloudDownloadIcon/>}
                                >
                                    {isDownloading ? "გთხოვთ დაელოდოთ..." : "დოკუმენტების გადმოწერა"}
                                </Button>
                            </span>
                        </Tooltip>
                    </div>
                    <div className="certificate-files-count-box-container">
                        <div style={{marginTop: 10}} className="certificate-files-count-box">
                            <div>
                                {loading ? (
                                    <CircularProgress size={24}/>
                                ) : (
                                    <>
                                        <span style={{
                                            verticalAlign: 'middle',
                                            marginRight: 5
                                        }}>ნაპოვნია {totalCount} დოკუმენტი</span>
                                        <FaSearch size={18} style={{verticalAlign: 'middle'}}/>
                                    </>
                                )}
                            </div>
                        </div>
                        {selectedFiles.length === totalCount && totalCount !== 0 && (
                            <div style={{marginTop: 10}} className="certificate-files-count-box">
                                <div>

                                    <div style={{
                                        verticalAlign: 'middle',
                                        marginRight: 5
                                    }}>
                                        თქვენ მონიშნეთ ყველა დოკუმენტი!
                                    </div>

                                </div>
                            </div>
                        )}

                        {selectedFiles.length > 0 && (
                            <div style={{marginTop: 10}} className="certificate-files-count-box">
                                <div>

                                    <div style={{
                                        verticalAlign: 'middle',
                                        marginRight: 5
                                    }}>
                                        მონიშნულია {selectedFiles.length} დოკუმენტი
                                    </div>
                                    <FaFileAlt size={18} style={{verticalAlign: 'middle'}}/>

                                </div>

                            </div>
                        )}

                    </div>


                    <div style={{marginTop: 20}}></div>

                    {loading ? (
                        <div className="nothing-found-message">
                            <CircularProgress color="primary"/>
                            <p>გთხოვთ დაელოდოთ...</p>
                        </div>
                    ) : alertMessage !== "" ? (
                        <div className="nothing-found-message">
                            <FontAwesomeIcon icon={faSearch} size="3x"/>
                            <p>{alertMessage}</p>
                        </div>
                    ) : filesList.length === 0 ? (
                        <div className="nothing-found-message">
                            <FontAwesomeIcon icon={faSearch} size="3x"/>
                            <p>არაფერი მოიძებნა!</p>
                        </div>
                    ) : (
                        <Paper sx={{width: '100%', overflow: 'hidden'}}>
                            <TableContainer>
                                <Table stickyHeader aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell padding="checkbox">
                                                <Tooltip
                                                    placement={"top"}
                                                    title={totalCount > 0 && selectedFiles.length === documentIds.length ? "გაუქმება" : "ყველას მონიშვნა"}>
                                                    <span>
                                                        <Checkbox
                                                            color="primary"
                                                            indeterminate={selectedFiles.length > 0 && selectedFiles.length < filesList.length}
                                                            checked={totalCount > 0 && selectedFiles.length === documentIds.length}
                                                            onChange={handleSelectAll}
                                                        />
                                                    </span>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell align={'center'}>განაცხადის ნომერი</TableCell>
                                            <TableCell align={'center'}>დოკუმენტის ნომერი</TableCell>
                                            <TableCell align={'center'}>სახელი</TableCell>
                                            <TableCell align={'center'}>ობიექტი</TableCell>
                                            <TableCell align={'center'}>შეიქმნა</TableCell>
                                            <TableCell align={'center'}>აქვს ხელმოწერა</TableCell>
                                            <TableCell align={'center'}>ქმედება</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody className="certificate-files-table">
                                        {filesList.map((file) => (
                                            <TableRow
                                                key={file.id}
                                                selected={isSelected(file.id)}
                                                onClick={() => handleSelect(file.id)}
                                                role="checkbox"
                                                hover
                                                style={{cursor: 'pointer'}}
                                            >
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        checked={isSelected(file.id)}
                                                        inputProps={{'aria-labelledby': `enhanced-table-checkbox-${file.id}`}}
                                                    />
                                                </TableCell>

                                                <TableCell align={'center'}
                                                           onClick={(event) => {
                                                               event.stopPropagation();
                                                               const caseId = file.caseNumber.split('-')[0];
                                                               window.open("/dashboard/mycases/casemanager?id=" + caseId, '_blank');
                                                           }}

                                                           className={"certificate-files-casenumber"}>
                                                    {file.caseNumber}
                                                </TableCell>

                                                <TableCell align={'center'}>{file.caseFileNumber}</TableCell>
                                                <TableCell align={'center'}>{file.caseFileName}</TableCell>
                                                <TableCell
                                                    align={'center'}>{findObjectNameById(file.permitTypeId)}
                                                </TableCell>
                                                <TableCell
                                                    align={'center'}>{formatDate(file.createAt)}
                                                </TableCell>
                                                <TableCell
                                                    align={'center'}>{file.isDocumentSigned ? "კი" : "არა"}
                                                </TableCell>


                                                <TableCell align={'center'}>
                                                    <a href={file.url} target="_blank"
                                                       rel="noopener noreferrer"
                                                       style={{textDecoration: 'none'}}>
                                                        <AiOutlineFile
                                                            className={"certificate-files-documenticon"}/>
                                                    </a>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                margin: '20px 0'
                            }}>
                                <Pagination
                                    count={Math.ceil(totalCount / pageSize)}
                                    page={page}
                                    onChange={(event, value) => setPage(value)}
                                    color="primary"
                                />
                                <FormControl>
                                    <InputLabel id="page-size-label">მაჩვენე</InputLabel>
                                    <Select
                                        variant={"outlined"}
                                        labelId="page-size-label"
                                        value={pageSize}
                                        style={{width: 75, marginRight: 10}}
                                        label="მაჩვენე"
                                        onChange={e => {
                                            setPageSize(e.target.value);
                                            setPage(1); // Reset to page 1 when page size changes
                                        }}
                                    >
                                        {[10, 20, 30, 40, 50, 100].map(size => (
                                            <MenuItem key={size} value={size}>{size}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>


                        </Paper>

                    )}
                    {showAlert && (
                        <CustomAlert
                            message={alertMessage}
                            type={alertType}
                            onClose={() => setShowAlert(false)}
                        />
                    )}
                </div>
            </Box>
        </div>
    );
};

export default DocumentsTable;
